import React, { useState, useEffect } from "react";
import Select from "react-select";

const CountryDropdown = ({ onSelectChange, hasError }) => {
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);

  useEffect(() => {
    fetch("/js/countries.json")
      .then((response) => response.json())
      .then((data) => {
        const formattedCountries = data.map((country) => ({
          value: country.dial_code,
          label: `${country.name}`,
        }));
        setCountries(formattedCountries);
      })
      .catch((error) => console.error("Error fetching countries:", error));
  }, []);

  const handleChange = (selectedOption) => {
    setSelectedCountry(selectedOption);
    onSelectChange(selectedOption?.value || '');
    console.log("Selected country code:", selectedOption?.value);
  };

  return (
    <Select
      options={countries}
      value={selectedCountry}
      onChange={handleChange}
      classNamePrefix="custom-select"
      isSearchable
      isClearable
      placeholder="Country"
      className={hasError ? "error-border" : ""}
      styles={{
        control: (base) => ({
          ...base,
          borderColor: hasError ? "red" : base.borderColor,
          boxShadow: hasError ? "0 0 5px red" : base.boxShadow,
        }),
      }}
    />
  );
};

export default CountryDropdown;
